import { Injectable } from '@angular/core';
import { SocketService } from 'app/services/socket.service';
import { WebApisService } from 'app/services/web-apis.service';
import { AuthenticationService } from 'app/auth/service/authentication.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Ticker } from 'app/interfaces/ticker';
import { map, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  public backBtnClass = 'btn btn-sm btn-outline-primary';
  public nextBtnClass = 'btn btn-sm btn-primary btn-next';
  public selectedTickerInfo = new BehaviorSubject<Ticker>(null);
  public shareTicker = this.selectedTickerInfo.asObservable();
  private _unsubscribeAll: Subject<any>;
  private userID: string = 'null';
  constructor(
    private webApi: WebApisService,
    private socket: SocketService,
    private authService: AuthenticationService
  ) { 
    this._unsubscribeAll = new Subject();
    this.initSocket();
    this.authService.currentUser.pipe(takeUntil(this._unsubscribeAll)).subscribe((user:any) =>{
      if(user){
        this.userID = user.user.id;
      }
    });
  }
  
  initSocket(){
    this.socket.on("connect", ()=>{
    });

    this.socket.on("close", ()=>{
    });

    this.socket.on("error", ()=>{
      console.log("socket error");
    });
  }

  getSocketTicker(){
    return this.socket.fromEvent('crypto-ticker-updates');
  }

  subcribeSocket(){
    this.socket.emit('subscribe', 'crypto-ticker-updates');
  }

  unsubcribeSocket(){
    this.socket.emit('unsubscribe', 'crypto-ticker-updates');   
  }

  setCryptoTicker(row: Ticker){
    row.price = Number(row.price.toFixed(2));
    row.percentageChange = Number((((Number(row.price) / Number(row.previousClose)) - 1) * 100).toFixed(2))
    this.selectedTickerInfo.next(row);
  }

  /* crypto pagination api */
  getCryptoPagination(pageNumber: number, tickerPerPage: number, searchTerm: string){
    let offset = tickerPerPage * (pageNumber - 1);
    if(searchTerm){
      return this.webApi.get(`/crypto/ticker/search/${searchTerm}?limit=${tickerPerPage}&offset=${offset}`);
    } else {
      return this.webApi.get(`/crypto/ticker?limit=${tickerPerPage}&offset=${offset}&sort=favorability_score`);
    }
  }

  getCryptoTickerTodayData(tickername){
    return this.webApi.get<any>(`/crypto/ticker/${tickername}/aggregatedBars`);
  }

  getCryptoTickerByName(tickername){
    return this.webApi.get<any>(`/crypto/ticker/${tickername}`);
  }

  getCryptoTickerHistoricalData(){
    return this.webApi.get<any>(`/crypto/ticker/${this.selectedTickerInfo.value.ticker}/socialsentiment`);
  }

  getCryptoTickerTechnical(data: Ticker){
    return this.webApi.get<any>(`/crypto/ticker/${data.ticker}/technical`);
  }

  getCryptoSocialSentimentTrends(pagename, pageNumber){
    let offset = 20 * (pageNumber - 1);
    return this.webApi.get<any>(`/crypto/${pagename}?ticker=${this.selectedTickerInfo.getValue().ticker}&limit=20&offset=${offset}`);
  }

  deleteCryptoSocialSentiment(obj_id){
    return this.webApi.delete<any>(`/crypto/socialsentiment/${obj_id}`,null);
  }

  addCryptoSocialSentiment(data: any){
    data.UserID = this.userID;
    return this.webApi.post<any>(`/crypto/socialsentiment`, data);
  }

  getCryptoUserSocialSentiment(page_name){
    return this.webApi.get<any>(`/crypto/socialsentiment/${page_name}/user/${this.userID}`).pipe(
      map(actions => {
        return actions.data;
      })
    );
  }

  getCryptoPortfolioTickers(){
    return this.webApi.get<any>(`/crypto/portfolio/user/${this.userID}/ticker`);
  }

  deleteCryptoPortfolioTicker(ticker){
    return this.webApi.delete<any>(`/crypto/portfolio/user/${this.userID}/ticker/${ticker}`, null);
  }

  addCryptoPortfolio(data){
    return this.webApi.post<any>(`/crypto/portfolio/user/${this.userID}/bulk`, data);
  }

  getWishlistTickers(){
    return this.webApi.get<any>(`/crypto/watchlist/user/${this.userID}/ticker`);
  }

  deleteCryptoWishlistTicker(ticker){
    return this.webApi.delete<any>(`/crypto/watchlist/user/${this.userID}/ticker/${ticker}`, null);
  }

  addCryptoWishlist(data){
    return this.webApi.post<any>(`/crypto/watchlist/user/${this.userID}/bulk`, data);
  }

  getCryptoTrends(){
    return this.webApi.get<any>(`/crypto/trend`).pipe(
      map((actions:any)=>{
        return actions.data
      })
    );
  }

  getCryptoOnchainFundamentals(ticker: string){
    return this.webApi.get<any>(`/crypto/onChainAndFundamental/${ticker}`).pipe(
      map((actions:any)=>{
        return actions.data
      })
    );
  }

  getTrend(ticker: string){
    return this.webApi.get<any>(`/crypto/trend/${ticker}`);
  }

  getAtPortfolio(){
    return this.webApi.getV2<any>('/crypto/portfolio/alphatrend');
  }
}
